import { render, staticRenderFns } from "./JgpTree3.vue?vue&type=template&id=37257fb1&"
import script from "./JgpTree3.vue?vue&type=script&lang=js&"
export * from "./JgpTree3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports